module.exports = __webpack_public_path__ + "img/buy_code_icon .1d3f4052.png";